/**
* @file: 安全扶持计划
* @author: wence
*/
import React from 'react';
import PropType from 'prop-types';
import {Modal} from 'antd-mobile';
import {connect} from 'react-redux';
import Item from './item';

import {
    fetchActivityGetService,
    fetchInstanceGetInstance,
    fetchApimealPay,
    fetchRealName
} from '../../actions/buyAction';

import './index.less';
class SecurityPlan extends React.Component {
    static propTypes = {
        fetchActivityGetService: PropType.func,
        fetchInstanceGetInstance: PropType.func,
        fetchApimealPay: PropType.func,
        userLoginstate: PropType.object,
        activityGetService: PropType.object,
        instanceGetinstance: PropType.object
    }

    constructor(props) {
        super(props);

        this.state = {
            modal1: false,
            modal2: false,
            toast: false,
            toastTitle: '',
            lookUrl: ''
        };

        if (this.isPC()) {
            location.href = `/security/plan${location.search}`;
        }
    }

    componentDidUpdate(prevProps) {
        let nextUser = this.props.userLoginstate;
        if (!Object.is(nextUser, prevProps.userLoginstate)) {
            if (nextUser.status === 0) {
                this.props.fetchInstanceGetInstance().then(data => {
                    let key = Object.keys(data.data.data)[0];
                    this.props.fetchActivityGetService({'instance_id': key, route: 'plan'});
                });
            } else {
                this.props.fetchActivityGetService({route: 'plan'});
            }
        }
    }
    mealPay = item => {
        if (item.is_buy) {
            return false;
        }
        const {activityGetService, userLoginstate, instanceGetinstance} = this.props;

        if (!this.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
            let key = Object.keys(instanceGetinstance.data)[0];
            let json = {
                'instance_id': key,
                'service_id': item.service_id,
                'meal_id': item.meal_id
            };

            this.props.fetchApimealPay(json).then(data => {
                if (data.data.status === 0) { // 购买成功
                    this.hmt();
                    this.props.fetchActivityGetService({'instance_id': key});
                    this.setState({
                        modal2: true,
                        lookUrl: item.url
                    });
                } else if (data.data.status === 404008) { // 未实名
                    fetchRealName({'instance_id': key}).then(res => {
                        this.setState({
                            modal1: true,
                            authType: res && res.data && res.data['auth_type'] || 0
                        });
                    });
                } else if (data.data.status === 404008) { // 未登录
                    location.href = this.loginUrl();
                }
                else if (data.data.description) {
                    this.setState({
                        toastTitle: data.data.description,
                        toast: true
                    });
                }
            });
        } else {
            location.href = this.loginUrl();
        }
    }

    onClose = key => {
        this.setState({
            [key]: false
        });
    };

    hmt() {
        try {
            window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
        }
        catch (e) {
            return;
        }
    }

    render() {
        const {toast, modal2, modal1, lookUrl} = this.state;
        const {activityGetService} = this.props;
        return (
            <div className="spu-plan">
                <div className="spu-plan-banner">
                    <a href="/m/apply" className="spu-btn">立即咨询</a>
                </div>
                <div style={{background: '#FFF'}}>
                    <div className="spu-plan-title">
                        <span className="text">关于百度安全扶持计划</span>
                    </div>

                    <p className="arctile margin">{`百度安全扶持计划，为百度安全面向广大初创企业及开发者开放的一系列安全
                    能力和扶持资源，致力于降低企业的安全部署成本，快速对齐国家、
                    行业安全标准与规范，护航企业安全“起飞”。`}</p>
                    <p className="arctile">{`长期以来，百度安全以技术开源、专利共享、标准驱动为理念，
                    联合行业生态伙伴，共同推动AI时代的安全生态建设。
                    作为百度安全开放战略的重要组成部分，扶持计划从技术、服务、合规性三个层面，
                    免费提供面向`}
                    <span>初创型智能硬件厂商</span>
                    {'、'}
                    <span>中小App开发者</span>
                    {'、'}
                    <span>有线上资产的中小企业</span>{'三类企业用户的安全防护资源。'}</p>

                    <div className="spu-plan-title">
                        <span className="text">初创企业三大安全痛点</span>
                    </div>

                    <div className="spu-plan-pain">
                        <div className="spu-plan-pain-item">
                            <div className="image icon_1"></div>
                            <div className="content">
                                <div className="title">安全威胁</div>
                                <div className="des">黑产系统运作、攻防对抗升级、经济损失巨大</div>
                            </div>
                        </div>
                        <div className="spu-plan-pain-item">
                            <div className="image icon_2"></div>
                            <div className="content">
                                <div className="title">成本控制</div>
                                <div className="des">部署复杂、成本高昂、人才掣肘</div>
                            </div>
                        </div>
                        <div className="spu-plan-pain-item">
                            <div className="image icon_3"></div>
                            <div className="content">
                                <div className="title">监管要求</div>
                                <div className="des">《网络安全法》实施、个人信息保护成整治重点</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="spu-plan-title">
                    <span className="text">扶持方式</span>
                </div>

                <div className="spu-plan-way">
                    <div className="spu-plan-way-item">
                        <div className="title icon_1">智能硬件“安全+”扶持计划</div>
                        <div className="sub-title">20000台安全OTA额度</div>
                        <div className="des">降低OTA成本，提高设备安全系数</div>
                        <div className="sub-title">免费安全加固、评估、咨询服务</div>
                        <div className="des">专业技术人员支持，渗透测试、等保测评、安全咨询等</div>
                        <div className="sub-title">业界领先的安全技术实力</div>
                        <div className="des">百度多项专利+20年安全行业实践双重保障，专业、可信赖</div>

                        <a href="https://ota.baidu.com/support.html" className="spu-btn">了解详情</a>
                    </div>
                    <div className="spu-plan-way-item">
                        <div className="title icon_2">个人信息保护扶持计划</div>
                        <div className="sub-title">App隐私合规风险检测服务</div>
                        <div className="des">5次/天隐私合规检测，高效生成风险评估结果</div>
                        <div className="sub-title">深度贴合国家监管标准</div>
                        <div className="des">预警合规风险，方便企业及时整改</div>
                        <div className="sub-title">合规培训</div>
                        <div className="des">个人信息保护沙龙，紧跟行业趋势</div>

                        <a href="https://anquan.baidu.com/springer/plan" className="spu-btn">了解详情</a>
                    </div>
                    <div className="spu-plan-way-item">
                        <div className="title icon_3">漏洞扫描扶持计划</div>
                        <div className="sub-title">Web漏洞扫描服务</div>
                        <div className="des">快速发现潜在风险，防御黑产攻击、规避法律风险</div>
                        <div className="sub-title">专业版限免试用及特殊折扣通道</div>
                        <div className="des">资产发现、网站安全漏洞与内容风险检测、规避挂马、内容篡改风险</div>
                        <a href="https://anquan.baidu.com/page/5" className="spu-btn">了解详情</a>
                    </div>

                    <div className="spu-plan-way-item">
                        <div className="title icon_4">APP消息推送扶持计划</div>
                        <div className="sub-title">提供成熟专业的消息推送服务</div>
                        <div className="des">支持百亿级的消息推送，已服务多个百度系产品</div>
                        <div className="sub-title">覆盖各类型推送需求和功能</div>
                        <div className="des">支持多类型推送，画像定向推送，定时推送和全方位数据统计</div>
                        <div className="sub-title">使用轻量简单安全可靠</div>
                        <div className="des">轻量SDK集成使用，采用百度智能心跳探测技术保障到达率</div>
                        <a href="https://anquan.baidu.com/page/60" className="spu-btn">了解详情</a>
                    </div>

                    <div className="spu-plan-way-item">
                        <div className="title icon_5"></div>
                        <div className="sub-title">免费提供风控服务</div>
                        <div className="des">营销风控及渠道反作弊服务全面支持</div>
                        <div className="sub-title">超亿级别黑产识别数据</div>
                        <div className="des">海量黑产手机账号设备数据</div>
                        <div className="sub-title">精准设备指纹</div>
                        <div className="des">覆盖百度系主流APP，识别群控异常登录</div>
                        <a href="/control/plan" className="spu-btn">了解详情</a>
                    </div>
                </div>

                <div className="spu-plan-process">
                    <div className="spu-plan-title">
                        <span className="text">入驻流程</span>
                    </div>
                    <div className="image"></div>
                    <p>安全不是任何一家公司能够独立解决的事情需在<span>开放共享</span>中寻求<span>生态共赢</span></p>
                    <p>技术不仅是企业决定胜负的重要筹码更需在<span>开放共享</span>中创造<span>更大价值</span></p>
                </div>

                <div className="spu-plan-title">
                    <span className="text">其他免费试用安全服务</span>
                </div>
                <a href="/m/buy" className="spu-link push-btn">前往免费套餐体验馆</a>
                <div className="spu-service-list">
                    {!this.isEmptyobj(activityGetService)
                        ? activityGetService.data.map((item, index) => {
                            return <Item
                                item={item}
                                key={index}
                                onClick={this.mealPay.bind(this, item)} />;
                        })
                        : null
                    }
                </div>

                <Modal
                    visible={modal1}
                    transparent
                    maskClosable={true}
                    className={'saas-attest'}
                    onClose={this.onClose.bind(this, 'modal1')}
                >
                    <div className={'hint'}>
                        您的账号还没有认证，认证后才能购买哦！
                    </div>
                    <a
                        className={'saas-buy-btn'}
                        href={this.state.authType === 0
                            ? this.userCenterUrl()
                            : '/console/#/attestation'
                        }
                        onClick={() => {
                            this.setState({
                                modal1: false
                            });
                        }}
                    >
                        去认证
                    </a>
                </Modal>

                <Modal
                    visible={modal2}
                    transparent
                    maskClosable={false}
                    className={'saas-attest'}
                    onClose={this.onClose.bind(this, 'modal2')}
                >
                    <div className={'hint'}>
                        购买成功，可前往控制台查看使用说明
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn hint-btn'}
                            href={lookUrl}
                            target={'_blank'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            去控制台
                        </a>
                        <div
                            className={'saas-buy-btn'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            继续购买
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={toast}
                    transparent
                    maskClosable={false}
                    wrapClassName="spu-modal-confirm"
                    className={'saas-attest'}
                    onClose={this.onClose.bind(this, 'modal2')}
                >
                    <div className={'hint'}>
                        {this.state.toastTitle}
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn'}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    toast: false,
                                    toastTitle: ''
                                });
                            }}
                        >
                            关闭
                        </a>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default connect(state => ({
    userLoginstate: state.userLoginstate,
    activityGetService: state.activityGetService,
    instanceGetinstance: state.instanceGetinstance
}), dispatch => ({
    fetchApimealPay: obj => fetchApimealPay(dispatch, obj),
    fetchActivityGetService: obj => fetchActivityGetService(dispatch, obj),
    fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)
}))(SecurityPlan);



// WEBPACK FOOTER //
// ./src/containers/securityPlan/index.jsx